import type {
  CartAdd as CartAddType,
  CartError as CartErrorType,
  Cart as CartType,
  CartUpdate as CartUpdateType,
} from '@grafikr/shopify-typescript/type/endpoints/Cart';

import Queue from './queue';

type ResponseHandler<T> = {
  success?: (body: T) => void;
  error?: (body: CartErrorType) => void;
};

export default new (class Cart {
  private queue: Queue;

  constructor() {
    this.queue = new Queue();
  }

  private sendRequest(input: RequestInfo | URL, init?: RequestInit) {
    return this.queue.add(() =>
        fetch(input, {
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          ...init,
        }),
    );
  }

  private static handleResponse<T>(response: Response, { success, error }: ResponseHandler<T>) {
    response.json().then((body) => {
      if (response.ok && success) {
        success(body);
      }

      if (!response.ok && error) {
        error(body);
      }
    });
  }

  async add(data: FormData, handler: ResponseHandler<CartAddType>): Promise<void> {
    const response = await this.sendRequest(`${theme.routes.cartAdd}.js`, {
      method: 'post',
      body: data,
    });

    Cart.handleResponse(response, handler);
  }

  async get(handler: ResponseHandler<CartType>): Promise<void> {
    const response = await this.sendRequest(`${theme.routes.cart}.js`);

    Cart.handleResponse(response, handler);
  }

  async update(data: FormData, handler: ResponseHandler<CartUpdateType>): Promise<void> {
    const response = await this.sendRequest(`${theme.routes.cartUpdate}.js`, {
      method: 'post',
      body: data,
    });

    Cart.handleResponse(response, handler);
  }

  async change(data: FormData, handler: ResponseHandler<CartUpdateType>): Promise<void> {
    const response = await this.sendRequest(`${theme.routes.cartChange}.js`, {
      method: 'post',
      body: data,
    });

    Cart.handleResponse(response, handler);
  }

  async clear(handler: ResponseHandler<Cart>): Promise<void> {
    const response = await this.sendRequest(theme.routes.cartClear, {
      method: 'post',
    });

    Cart.handleResponse(response, handler);
  }
})();
